// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1Te4Q","selects":"Documents_selects__2_kMu"};